// pages/FormViewerPage/hooks/useFormViewer/statePixels.ts — state pixel & platform (split dari state.ts)
import { useState } from 'react';
import type { PlatformPixelConfig } from '../../types';

export function usePixelStates() {
    const [activePlatform, setActivePlatform] = useState<'meta' | 'tiktok' | 'google' | 'snack' | 'openai' | null>(null);
    const [formPagePixelConfigs, setFormPagePixelConfigs] = useState<PlatformPixelConfig[]>([]);
    const [thankYouPagePixelConfigs, setThankYouPagePixelConfigs] = useState<PlatformPixelConfig[]>([]);
    const [formPagePixels, setFormPagePixels] = useState<{ ids: string[]; eventName: string }>({ ids: [], eventName: 'ViewContent' });
    const [thankYouPagePixels, setThankYouPagePixels] = useState<{ ids: string[]; eventName: string }>({ ids: [], eventName: 'Lead' });
    const [activePixelIds, setActivePixelIds] = useState<string[]>([]);
    const [eventNames, setEventNames] = useState<{ formPage: string; thankYouPage: string }>({ formPage: 'ViewContent', thankYouPage: 'Lead' });
    const [pixelsByPlatform, setPixelsByPlatform] = useState<Record<string, { ids: string[]; eventName: string }>>({
        meta: { ids: [], eventName: 'ViewContent' },
        google: { ids: [], eventName: 'view_item' },
        tiktok: { ids: [], eventName: 'ViewContent' },
        snack: { ids: [], eventName: 'ViewContent' },
        openai: { ids: [], eventName: 'ViewContent' },
    });
    const [pixelsLoaded, setPixelsLoaded] = useState(false);
    return {
        activePlatform, setActivePlatform, formPagePixelConfigs, setFormPagePixelConfigs,
        thankYouPagePixelConfigs, setThankYouPagePixelConfigs, formPagePixels, setFormPagePixels,
        thankYouPagePixels, setThankYouPagePixels, activePixelIds, setActivePixelIds,
        eventNames, setEventNames, pixelsByPlatform, setPixelsByPlatform,
        pixelsLoaded, setPixelsLoaded,
    };
}
